export const TTCommons = require("./TTCommons/TTCommons-Regular.ttf");
